<div class="header-navigation-back">
  <mat-icon (click)="onNavigateToProfile()">arrow_back</mat-icon>
  <span class="title">Road Test</span>
</div>
<div >
  <div class="padding-sides-2x">
    @if (!driveTest) {
      <p>
        <b> We are yet to
        recieve/process your Road Test report.</b></p>
      }
      @if (driveTest) {
        <p>
          Your Road Test
          document
        was uploaded to our system on {{driveTest.createdDate|date: 'dd/MM/yyyy'}}.</p>
      }
      <p>If you need further assistance, please get in touch with one of our support
        group at <u>support&#64;FleetOperate.com</u>.</p>
      </div>
    </div>